import React, { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import { getUsers, deleteUser } from "../../../services/user";
import Sidebar from "../../../components/Sidebar"; // Changed import
import { Container, Card, CardBody, CardTitle, Table, Button } from "reactstrap";

const UserManagementPage = () => {
  const [users, setUsers] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    fetchUsers();
  }, []);

  const fetchUsers = async () => {
    try {
      const response = await getUsers();
      setUsers(response.data);
    } catch (error) {
      console.error("Failed to fetch users:", error);
    }
  };

  const handleDelete = async (id) => {
    if (window.confirm("Êtes-vous sûr de vouloir supprimer cet utilisateur ?")) {
      try {
        await deleteUser(id);
        fetchUsers(); // Refresh the list
      } catch (error) {
        console.error("Failed to delete user:", error);
      }
    }
  };

  return (
    <div className="admin-view d-flex h-100 w-100">
      <Sidebar />
      <div className="main-content w-100" style={{ height: "100vh", padding: 50 }}>
        <Card className="h-100">
          <CardBody>
            <div className="d-flex justify-content-between align-items-center">
              <CardTitle tag="h4">Gestion des Utilisateurs</CardTitle>
              <Link to="/admin/users/new" className="btn btn-primary">
                Ajouter un utilisateur
              </Link>
            </div>

            <div className="table-responsive mt-4 h-100">
              <Table
                responsive
                className="table table-centered table-nowrap mb-0 text-center"
                style={{ height: "100%", width: "100%" }}>
                <thead className="table-light">
                  <tr>
                    <th>ID</th>
                    <th>Prénom</th>
                    <th>Nom</th>
                    <th>Email</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {users &&
                    users?.map((user) => (
                      <tr key={user?.id}>
                        <td>{user?.id}</td>
                        <td>{user?.firstname}</td>
                        <td>{user?.lastname}</td>
                        <td>{user?.email}</td>
                        <td>
                          <Link
                            to={`/admin/users/edit/${user?.id}`}
                            className="btn btn-light btn-sm me-2">
                            Modifier
                          </Link>
                          <Button
                            color="danger"
                            size="sm"
                            onClick={() => handleDelete(user?.id)}>
                            Supprimer
                          </Button>
                        </td>
                      </tr>
                    ))}
                </tbody>
              </Table>
            </div>
          </CardBody>
        </Card>
      </div>
    </div>
  );
};

export default UserManagementPage;
